/* ------------ -------------- ------------*/
/* ------------  Validate Form ------------*/
/* ------------ -------------- ------------*/

export default  (values) =>{

    const errors = {}
    if (!values.title) {
        errors.title = 'این فیلد ضروری است'
    }
    if (!values.price) {
        errors.price = 'این فیلد ضروری است'
    }
    if (!values.commission) {
        errors.commission = 'این فیلد ضروری است'
    }
    if (values.product_category < 0 ||  typeof  values.product_category == 'undefined') {
        errors.product_category = 'این فیلد ضروری است'
    }

    return errors
};